import { gql } from "graphql-tag";
import { basePageableGraphqlField, responseField } from "../../../base.graphql";
import {StoreItemFiltering} from "../../store-item/store-item.model";

export const itemDashboardFields = `
avgTemperature
avgHumidity
highestTemperature
highestHumidity
lowestTemperature
lowestHumidity
`;


export const GET_TEMPERATURE_ZONE_DASHBOARD_DATA=gql`
query GetTemperatureZoneDashboardData($filtering: ReadingsFilteringObject) {
  getTemperatureZoneDashboardData(filtering: $filtering) {
    response {
      ${responseField}
    }
    data {
      ${itemDashboardFields}
    }
  }
}
`

export const GET_WAREHOUSE_DASHBOARD_DATA=gql`
query getWarehouseDashboardData($filtering: DrillDownFilteringInputObject) {
  getWarehouseDashboardData(filtering: $filtering) {
    response {
      ${responseField}
    }
    page {
      ${basePageableGraphqlField}
    }
    data {
      dashboardData
    }
  }
}
`
export const GET_WAREHOUSE_REALTIME_READINGS=gql`
query getWarehouseRealTimeReadings($filtering: DrillDownFilteringInputObject) {
  getWarehouseRealTimeReadings(filtering: $filtering) {
    response {
      ${responseField}
    }
    page {
      ${basePageableGraphqlField}
    }
    data {
      dashboardData
    }
  }
}
`
export const GET_WAREHOUSE_FORECAST_DATA=gql`
query getWarehouseForecastData($filtering: ReportsFilteringInputObject) {
  getWarehouseForecastData(filtering: $filtering) {
    response {
      ${responseField}
    }
    data {
      dashboardData
    }
  }
}
`
